<template>
  <div class="-mt-10 md:-mt-12 bg-grey-light md:mx-5 xl:mx-8">
    <div class="flex flex-wrap sm:flex-nowrap items-center justify-between container text-center py-6 px-8 mb-8 gap-y-4">
      <div class="w-full md:w-1/3">
        <p class="text-2xl md:text-3xl lg:text-4xl font-bold mb-2">{{ formattedFunding }}</p>
        <div class="border-b-2 border-red w-32 mx-auto mb-4"></div>
        <p class="text-sm md:text-base mb-4">Total amount of funding</p>
      </div>
      <div class="w-full md:w-1/3">
        <p class="text-2xl md:text-3xl lg:text-4xl font-bold mb-2">{{ totalHits ?? 0 }}</p>
        <div class="border-b-2 border-red w-32 mx-auto mb-4"></div>
        <p class="text-sm md:text-base mb-4">Total projects</p>
      </div>
      <div class="w-full md:w-1/3">
        <p class="text-2xl md:text-3xl lg:text-4xl font-bold mb-2">{{ totalCountries ?? 0 }}</p>
        <div class="border-b-2 border-red w-32 mx-auto mb-4"></div>
        <p class="text-sm md:text-base mb-4">Countries covered</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

// Matches the site's "£4m" style compact formatting rather than a browser
// Intl formatter's own conventions (which would give "£848K"/"£848M").
function formatCompactGbp(amount) {
  if (!amount) return "£0";
  if (amount >= 1_000_000) {
    const millions = amount / 1_000_000;
    return `£${millions >= 10 ? Math.round(millions) : millions.toFixed(1)}m`;
  }
  if (amount >= 1_000) {
    return `£${Math.round(amount / 1000)}k`;
  }
  return `£${Math.round(amount).toLocaleString()}`;
}

export default {
  computed: {
    ...mapGetters(["totalHits", "totalFundingGbp", "totalCountries"]),
    formattedFunding() {
      return formatCompactGbp(this.totalFundingGbp);
    },
  },
};
</script>
